import Routes from "app/routes/Routes";
import Providers from "./ui/Providers";
import "./infrastructure/common/i18n/config";

function App() {
  return (
    <Providers>
      <Routes />
    </Providers>
  );
}

export default App;
